/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";
import { X } from "lucide-react";
import { Button } from "./Button";
import { Textarea } from "./texttarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./dialog";
import moment from "moment/moment";
import "moment/locale/es";

interface ReviewModalProps {
  onClick: any;
  loading: any;
  booking: any;
  onClose: () => void;
}

export default function ApprovedModal({
  onClick,
  loading,
  booking,
  onClose,
}: ReviewModalProps) {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Aprobar reserva</span>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <X className="w-4 h-4" />
            </Button>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {/* Booking Info */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium text-gray-900 mb-2">
              {booking.property_name || booking.excursion_name}
            </h3>
            <div className="text-sm text-gray-600 space-y-1">
              <div>Reserva #{booking.id}</div>
              <div>{booking.property[0]?.title}</div>
              <div>
                {`Checkin ${booking.checkin} Hrs ${moment(booking.start_date)
                  .locale("es")
                  .format("D [de] MMMM [de] YYYY")}`}{" "}
                -{" "}
                {`Checkout ${booking.checkout} Hrs ${moment(booking.end_date)
                  .locale("es")
                  .format("D [de] MMMM [de] YYYY")} `}
              </div>
              <div>{booking.guests} huéspedes</div>
            </div>
          </div>

          {/* Description */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">
              Mensaje del cliente
            </label>
            <Textarea
              value={booking.comments}
              rows={4}
              className="resize-none text-black border-0"
              disabled={true}
            />
          </div>

          {/* Submit Button */}
          <div className="flex gap-3 pt-4">
            <Button variant="outline" onClick={onClose} className="flex-1">
              Cancelar
            </Button>
            <Button
              onClick={(e) => onClick(e)}
              disabled={loading}
              name="pendiente"
              className="flex-1 bg-[#8B9456] hover:bg-[#7A8249] text-white"
            >
              {loading ? "Cancelando..." : "Aprobar reserva"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
